import type { GetCommentAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetCommentAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetCommentAuditByIdArgs = {
  id: string;
};

export const useGetCommentAuditById = createQueryHook<
  UseGetCommentAuditByIdArgs,
  GetCommentAuditByIdQuery['comment_audit'],
  GetCommentAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getCommentAuditById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({ comment_audit: data }),
  graphqlDocument: GetCommentAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
